import { CONSTANTS } from "./constants";
import { safeJsonParse } from "@src/utils/safeJsonParse";

const coursePrefix = `/v2/course`;
const coursePrefixV3 = `/v3/course`;
const urlPrefix = `${coursePrefix}/order`;
const dynamicBundlingPrefix = `/v3/course/order`;
const apiEndPoints = {
  [CONSTANTS.CREATE_ORDER_POST]: {
    url: () => `/v3/course/order/create`,
    method: "POST",
  },
  [CONSTANTS.CREATE_ORDER_POST_DYNAMIC_BUNDLING]: {
    url: () => `${dynamicBundlingPrefix}/create`,
    method: "POST",
  },
  [CONSTANTS.CREATE_CAPTURE_INTEREST]: {
    url: () => `/v3/course/order/intrest`,
    method: "POST",
  },
  [CONSTANTS.PAYMENT_CHECKOUT_GET]: {
    url: (id) => `${urlPrefix}/checkout/${id}`,
    method: "GET",
  },
  [CONSTANTS.CHECK_PAYMENT_STATUS_GET]: {
    url: (id) => `${urlPrefix}/${id}/status`,
    method: "GET",
  },
  [CONSTANTS.ADD_TO_CART_POST]: {
    url: (id) => `${coursePrefix}/cart/addNew`,
    method: "POST",
  },
  [CONSTANTS.GET_SIGNED_PAYLOAD_GET]: {
    url: (id) => `${coursePrefix}/cart/signedPayload`,
    method: "POST",
  },
  [CONSTANTS.GET_QR_PAYMENT_STATUS_RZP]: {
    url: (gatewayOrderId) => `${coursePrefixV3}/qr/order/${gatewayOrderId}/status`,
    method: "GET",
  },
  [CONSTANTS.PAYMENT_METHODS_GET]: {
    url: ({
      orgId,
      bundleId,
      installmentId,
      currentAmount,
      isGooglePlayEnabled,
      isNewPaymentFlow,
      isGbpsFlow,
      isOutsideIndia
    }) => {
      // isGbpsFlow=0 = Razorpay
      // isGbpsFlow=1 = Google Billing
      // isGbpsFlow=2 = Razorpay & Google Billing
      const isNewPaymentFlowValue = safeJsonParse(isNewPaymentFlow, {
        source: "apiEndPoints [isNewPaymentFlow]",
        fallback: false,
      });
      let url = `${coursePrefix}/payment/gateways?orgId=${orgId}&source=online_course_payment&currentAmount=${currentAmount}&isGooglePlayEnabled=${isGooglePlayEnabled}&isNewPaymentFlow=${isNewPaymentFlowValue}`;
      if (isGbpsFlow) {
        //if outside India and  isGbpsFlow=2 send isGbpsFlow= 1
        if (!!parseInt(isOutsideIndia) && parseInt(isGbpsFlow) === 2) {
          url += `&isGbpsFlow=${1}`;
        }
        else {
          url += `&isGbpsFlow=${isGbpsFlow}`;
        }

      }
      if (bundleId) {
        url += `&bundleId=${bundleId}`;
      }
      if (installmentId) {
        url += `&installmentId=${installmentId}`;
      }
      return url;
    },

    method: "GET",
  },
};

export default apiEndPoints;
